/** Feste Bildschirmgröße eines Taster- oder Steckdosenmoduls im Designplan. */
export const C1_ELO_PLAN_MODULE_SIZE = 19;
